import { RunContext } from "components/Run/Context";
import useAnalytics from "hooks/useAnalytics";
import useTypedContext from "hooks/useTypedContext";
import { ObservabilityProcessingStatus } from "types/generated";
import { isModuleRunType } from "utils/run";

import { showExportTracesDrawer } from "./Drawer";

const useExportTraces = () => {
  const { run, stack } = useTypedContext(RunContext);
  const trackSegmentAnalyticsEvent = useAnalytics();

  const traces = run.observabilityStatus?.traces;

  const hasTraces =
    !isModuleRunType(run.type) &&
    (traces === ObservabilityProcessingStatus.Available ||
      traces === ObservabilityProcessingStatus.PartialDataAvailable);

  const partial = traces === ObservabilityProcessingStatus.PartialDataAvailable;

  const label = partial ? "Export partial traces" : "Export traces";

  const openDrawer = () => {
    trackSegmentAnalyticsEvent("Run Observability - open export traces drawer");

    showExportTracesDrawer({ stackId: stack.id, runId: run.id, partial });
  };

  return { hasTraces, label, openDrawer };
};

export default useExportTraces;
